export default __webpack_public_path__ + "8fb343f77843e5e73b799e69d8658e66.svg";